const appInfo = window.__APP__;

// URL 쿼리에서 값을 읽는 헬퍼
const getQueryParam = (key: string): string => {
    return new URLSearchParams(window.location.search).get(key) || "";
};

// sessionStorage에 저장하고 반환
const getOrStoreParam = (key: string, storageKey: string, fallback: string = ""): string => {
    // 1. 네이티브 앱 정보
    if (key === "serviceId" && appInfo?.serviceId) return appInfo.serviceId;
    // 2. URL 쿼리 파라미터 (호출 시점에 직접 읽기)
    const fromUrl = getQueryParam(key);
    if (fromUrl) {
        sessionStorage.setItem(storageKey, fromUrl);
        return fromUrl;
    }
    // 3. sessionStorage 캐시
    return sessionStorage.getItem(storageKey) || fallback;
};

export const getStoredServiceId = (): string => {
    return getOrStoreParam("serviceId", "sso_serviceId");
};

export const getStoredOrigin = (): string => {
    return getOrStoreParam("origin", "sso_origin", "*");
};

export const getStoredReturnUrl = (): string => {
    return getOrStoreParam("returnUrl", "sso_returnUrl");
};

export const isSingleLoginApp = (): boolean => {
    return window.__APP__?.isSingleLogin === true;
};

export const App = {
    appName: appInfo?.appName || "",
    appVersion: appInfo?.appVersion || "",
    appBuild: appInfo?.appBuild || "",
    primaryColor: appInfo?.primaryColor || "#525fd3",
    serviceId: getStoredServiceId(),
    isSingleLogin: isSingleLoginApp(),
}
